import Vue from "vue";

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {},
  actions: {
    fetchOrder(ctx, params) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$rf
          .getRequest("CommonRequest")
          .getListEcomOrder(params)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchOrderById(ctx, { id, params }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$rf
          .getRequest("CommonRequest")
          .getDetailOrder(id, params)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    changeStatusOrder(ctx, params) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$rf
          .getRequest("CommonRequest")
          .changeStatusEcomOrder(params)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    changePaymentStatusOrder(ctx, params) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$rf
          .getRequest("CommonRequest")
          .changePaymentStatusEcomOrder(params)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
